// var EventType = require('../../constants/event-type.js');
// var WidgetType = require('../../constants/widget-type.js');
// var uniqueIdGenerator = require('../../utils/unique-id-generator.js');
// var BelongingComponent = require('../../constants/belonging-component.js');
// var StudioModels = require('../../models/studio-models.js');
// var CodeChartWidget = require('../dashboard/dashboard-widgets/line-static-domain/widget.jsx');
// var ChartWidget = require('../dashboard/dashboard-widgets/line-bar-chart/widget.jsx');
// var StudioService = require('../../services/studio-service.js');
// var WidgetService = require('../../services/widget-service.js');
// var WidgetComponentType = require('../../constants/widget-component-type.js');
//
// var CssHelper = require('../../utils/css-helper.js');
//
// var InternalEventBus = require('../../../../core/utils/internal-event-bus.js');
// var InternalEvent = require('../../../../core/constants/internal-event.js');
// var Configs = require('../../app-configs.js');
import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "../../../baseComponent.js";
import UniqueIdGenerator from "../../../../core/utils/uniqueIdGenerator.js";
import WidgetService from "../../../../core/services/widgetService.js";
import BelongingComponent from "../../../../core/constants/belongingComponent.js";
import LineStaticWidget from "../../../dashboard/widgets/line-static-chart/lineStaticWidget.jsx";
import AddWidget from "../../../dashboard/add-widget/addWidget.jsx";

export default class ChartContainer extends BaseComponent {
  constructor(props) {
    super(props);
    this.widgetId = UniqueIdGenerator.id();
    this.componentId = UniqueIdGenerator.id();
    this.mode = "line";
  }
  
  componentWillUnmount() {
    this.removeWidget();
  }

  componentDidMount() {
    // this.chartDataModel = new StudioModels.ChartDataModel(this.props.studioId, {});
    this.chartDataModel = {
      chartModels: []
    };
    this.renderChart();
  }

  removeWidget() {
    // Remove widget from widget store and unsubscribe data stream if needed

    // TODO: destroy ctrl?
    WidgetService.removeWidget(this.widgetId);

    ReactDOM.unmountComponentAtNode(document.getElementById(this.widgetId));

  }

  renderChart() {
    if (this.chartWidget) {
      ReactDOM.unmountComponentAtNode(document.getElementById(this.widgetId));
      WidgetService.removeWidget(this.widgetId);
    }

    // let legends = JSON.parse(JSON.stringify(this.props.model));

    this.chartWidget = WidgetService.createRealtimeWidget({
      widgetId: this.widgetId,
      legends: [],
      belongingComponent: BelongingComponent.STUDIO
    });

    console.log(this.chartWidget);

    // // this would happen when it is first time adding legend
    // if (that.chartDataModel.components == null) {
    //   // when component is null, means it is first time loading after adding
    //   var componentId = uniqueIdGenerator.getId();
    //   var widgetId = this.chartWidget.id;
    //   var componentType = WidgetComponentType.MAIN_EPOCH_CHART;
    //   that.chartDataModel.components = {};
    //   that.chartDataModel.components[componentId] = {
    //     controller: {
    //       id: componentId,
    //       widgetId: widgetId,
    //       type: componentType
    //     }
    //   };
    // }

    var componentId = UniqueIdGenerator.id();
    this.chartDataModel.components = {};
    this.chartDataModel.components[componentId] = {
      controller: {
        id: componentId,
        widgetId: this.chartWidget.id
      }
    };

    // temporary code to hardcode chart state

    if (this.props.model.id === "HvimdJQCqsPoHMXKnWLwvFTKuaxpAjKXlFA") {
      if (this.chartWidget.legends.length === 0 && this.chartDataModel.components == null) {
        // when component is null, means it is first time loading after adding
        var componentId = UniqueIdGenerator.id();
        var widgetId = this.chartWidget.id;
        // var componentType = WidgetComponentType.LINE_STATIC_DOMAIN;
        this.chartDataModel.components = {};
        this.chartDataModel.components[componentId] = {
          controller: {
            id: componentId,
            widgetId: widgetId,
            // type: componentType
          }
        };
      }
      if (this.chartWidget.legends.length === 0) {
        this.chartWidget.legends = JSON.parse('[{"id":1,"datasetId":"5ef080b0-0000-11e5-9206-e6d22ac3494e","valueFields":{"1":"Rate1","2":"Rate2","3":"Rate3","4":"Rate4","5":"Rate5","6":"Rate6","7":"Rate7","8":"Rate8","9":"Rate9","10":"Rate10","11":"Rate11"},"parameters":{"groupId":1,"legendLabel":"Yield","legendColor":"#ff7f0e","isActive":true,"legendSeqNo":0,"chartTypeParameters":{"fillOpacity":1,"strokeOpacity":1}}},{"id":2,"datasetId":"2f94efe0-9f53-11e5-0000-e6d22ac3494e","valueFields":{"1":"Rate1","2":"Rate2","3":"Rate3","4":"Rate4","5":"Rate5","6":"Rate6","7":"Rate7","8":"Rate8","9":"Rate9","10":"Rate10","11":"Rate11"},"parameters":{"groupId":2,"legendLabel":"Output","legendColor":"#9467bd","isActive":true,"legendSeqNo":1,"chartTypeParameters":{"fillOpacity":1,"strokeOpacity":1}}}]');
      }

      ReactDOM.render(React.createElement(LineStaticWidget, {
        model: this.chartWidget,
        components: this.chartDataModel.components,
      }), document.getElementById(this.widgetId));

    } else {
      ReactDOM.render(React.createElement(AddWidget, {
        model: this.chartWidget,
        components: this.chartDataModel.components,
        isStudioWidget: true
      }), document.getElementById(this.widgetId));
    }
    // temporary code END

    // $("span.simplecolorpicker").remove();
    // this.createColorPicker();
    // this.bindingChartRemoveEvent();
    //
    // var chartModels = this.chartDataModel.chartModels;
    // for (var i = 0; i < chartModels.length; i++) {
    //   this.changeChartIconColor(chartModels[i].datasetId, chartModels[i].fieldId, chartModels[i].parameters.legendColor);
    // }

  }

  render() {
    var style = {
      width: "100%",
      height: "100%",
      display: "flex",
      padding: "0 20px"
    };
    return (
      <div className="resizable resizable1" id="code-chart-container">
        <div id={this.widgetId} style={style}/>
        {/*<img src="img/chevron-down.png" className="chevron"/>*/}
        <div id="tooltips-container"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/analytic-studio/editor/chart/chartContainer.jsx